import { render, staticRenderFns } from "./informes.vue?vue&type=template&id=6febc1b4&lang=pug&"
import script from "./informes.vue?vue&type=script&lang=js&"
export * from "./informes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports